import script from "./talent.vue?vue&type=script&setup=true&lang=js"
export * from "./talent.vue?vue&type=script&setup=true&lang=js"

import "./talent.vue?vue&type=style&index=0&id=f00818f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f00818f4"]])

export default __exports__